<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import { Helper } from "@/mixin/helper";

export default {
  page: {
    title: "Penjadwalan Baru",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  mixins: [Helper],
  data() {
    return {
      id: this.$route.params.id,
      form: {
        report: "",
        period: "",
        receiver: [],
        fleetGroup: [],
        date: "",
        days: [],
      },
      reportOptions: [
        { value: 1, text: "Jam Kerja" },
        { value: 2, text: "Manajemen Kendaraan" },
        { value: 3, text: "Manajemen Pengemudi" },
        { value: 4, text: "Perilaku Pengemudi" },
        { value: 5, text: "Peringatan" },
        { value: 6, text: "Pintu" },
        { value: 7, text: "Ringkasan Geolokasi" },
        { value: 8, text: "Waktu Berhenti" },
      ],
      periodOptions: [
        { value: "d", text: "Harian" },
        { value: "w", text: "Mingguan" },
        { value: "m", text: "Bulanan" },
      ],
      receiverOptions: [
        { value: 1, text: "riswanto@mceasy.cloud" },
        { value: 2, text: "alfian_yudistira@mceasy.cloud" },
        { value: 3, text: "elena_gun@mceasy.cloud" },
        { value: 4, text: "mustain_putra@mceasy.cloud" },
        { value: 5, text: "bimo_sebastian@mceasy.cloud" },
        { value: 6, text: "abi@mceasy.cloud" },
        { value: 7, text: "dikaseptian@mceasy.cloud" },
        { value: 8, text: "eman@mceasy.cloud" },
      ],
      fleetGroup: [
        { value: "A", text: "Grup Kendaraan A" },
        { value: "B", text: "Grup Kendaraan B" },
        { value: "C", text: "Grup Kendaraan C" },
        { value: "D", text: "Grup Kendaraan D" },
        { value: "E", text: "Grup Kendaraan E" },
      ],
      dayOptions: [
        { value: 1, text: "Senin" },
        { value: 2, text: "Selasa" },
        { value: 3, text: "Rabu" },
        { value: 4, text: "Kamis" },
        { value: 5, text: "Jumat" },
        { value: 6, text: "Sabtu" },
        { value: 7, text: "Minggu" },
      ],
      dayState: {
        all: true,
        senin: false,
        selasa: false,
        rabu: false,
        kamis: false,
        jumat: false,
        sabtu: false,
        minggu: false,
      },
    };
  },
  validations: {
    form: {
      report: { required },
      period: { required },
      receiver: { required },
      fleetGroup: { required },
      date: { required },
      days: { required },
    },
  },
  computed: {
    title() {
      return this.$route.params.id === undefined
        ? "Penjadwalan Baru"
        : "Ubah Penjadwalan";
    },
    selectDateOptions() {
      var options = [];
      for (let i = 1; i <= 31; i++){
        options.push(i);        
      }
      return options;
    },
  },
  methods: {
    removeMultiselectKey(param) {
      this[param].splice(0, 1);
    },
    selectAllDays() {
      let obj = { ...this.dayState };
      Object.keys(obj).forEach(function (key) {
        if (key !== "all") {
          obj[key] = false;
        } else {
          obj[key] = true;
        }
      });
      this.dayState = obj;
    },
    selectDay(param) {
      this.dayState[param] = !this.dayState[param];
      if (param !== "all") {
        this.dayState.all = false;
      }
      this.toSave();
    },
    validate() {
      // Checking validation
      this.$v.$touch();
      if (this.$v.form.$error) {
        return false;
      }
      return true;
    },
    toCancel() {
      this.$router.push({ name: "Report Scheduler" });
    },
    toSave() {
      var days = [];
      if (this.dayState.senin) {
        days.push("Senin");
      }
      if (this.dayState.selasa) {
        days.push("Selasa");
      }
      if (this.dayState.rabu) {
        days.push("Rabu");
      }
      if (this.dayState.kamis) {
        days.push("Kamis");
      }
      if (this.dayState.jumat) {
        days.push("Jumat");
      }
      if (this.dayState.sabtu) {
        days.push("Sabtu");
      }
      if (this.dayState.minggu) {
        days.push("Minggu");
      }
      let obj = { ...this.dayState };
      let objArr = [];
      Object.keys(obj).forEach(function (key) {
        if (obj[key]) {
          objArr.push(key);
        }
      });
      let exceptAll = Object.keys(obj).filter((key) => key != "all").length;
      if (
        objArr.length === exceptAll ||
        objArr.length === 0 ||
        objArr[0] === "all"
      ) {
        this.selectAllDays();
      }
    },
  },
};
</script>
<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button @click="toCancel" variant="outline-primary" class="mx-2">
            <i class="mc-fa icon-fill_close"></i> {{ $t("global.cancel") }}
          </b-button>
          <b-button @click="validate" variant="primary" type="button">
            <i class="mc-fa icon-outline_save"></i> {{ this.$t("global.save") }}
          </b-button>
        </div>
      </div>
    </div>
    <div class="mc-form">
      <b-card>
        <b-row class="mb-3">
          <b-col cols="6">
            <b-form-group
              label-cols-lg="4"
              content-cols-lg="8"
              label="Laporan"
              label-for="report-name"
              label-class="required"
            >
              <multiselect
                id="report-name"
                v-model="form.report"
                :options="reportOptions"
                track-by="value"
                label="text"
                placeholder="Pilih laporan"
                :class="{ 'is-invalid': $v.form.report.$error }"
              ></multiselect>
              <div v-if="$v.form.report.$error" class="invalid-feedback">
                <span v-if="!$v.form.report.required">
                  Nama Laporan
                  {{ $t("global.validation.required") }}
                </span>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col>
            <b-form-group
              label-cols-lg="4"
              content-cols-lg="8"
              label="Periode"
              description="Pengiriman email setiap - pukul 08.00 pagi."
              label-for="period"
              label-class="required"
            >
              <multiselect
                id="period"
                v-model="form.period"
                :options="periodOptions"
                track-by="value"
                label="text"
                placeholder="Pilih periode"
                :class="{ 'is-invalid': $v.form.period.$error }"
              ></multiselect>
              <div v-if="$v.form.period.$error" class="invalid-feedback">
                <span v-if="!$v.form.period.required">
                  Periode
                  {{ $t("global.validation.required") }}
                </span>
              </div>
            </b-form-group>
          </b-col>
          <b-col>
            <div v-if="form.period.value == 'w'" class="row mt-2">
              <div class="col-md-12">
                <div class="mc-table-filter__status pb-4">
                  <b-button
                    :variant="dayState.all ? 'secondary' : 'light'"
                    size="sm"
                    class="me-2"
                    @click="selectDay('all')"
                  >
                    Semua
                  </b-button>
                  <b-button
                    :variant="dayState.senin ? 'secondary' : 'light'"
                    size="sm"
                    class="me-2"
                    @click="selectDay('senin')"
                  >
                    Senin
                  </b-button>
                  <b-button
                    :variant="dayState.selasa ? 'secondary' : 'light'"
                    size="sm"
                    class="me-2"
                    @click="selectDay('selasa')"
                  >
                    Selasa
                  </b-button>
                  <b-button
                    :variant="dayState.rabu ? 'secondary' : 'light'"
                    size="sm"
                    class="me-2"
                    @click="selectDay('rabu')"
                  >
                    Rabu
                  </b-button>
                  <b-button
                    :variant="dayState.kamis ? 'secondary' : 'light'"
                    size="sm"
                    class="me-2"
                    @click="selectDay('kamis')"
                  >
                    Kamis
                  </b-button>
                  <b-button
                    :variant="dayState.jumat ? 'secondary' : 'light'"
                    size="sm"
                    class="me-2"
                    @click="selectDay('jumat')"
                  >
                    Jumat
                  </b-button>
                  <b-button
                    :variant="dayState.sabtu ? 'secondary' : 'light'"
                    size="sm"
                    class="me-2"
                    @click="selectDay('sabtu')"
                  >
                    Sabtu
                  </b-button>
                  <b-button
                    :variant="dayState.minggu ? 'secondary' : 'light'"
                    size="sm"
                    class="me-2"
                    @click="selectDay('minggu')"
                  >
                    Minggu
                  </b-button>
                </div>
              </div>
            </div>
            <b-form-group v-if="form.period.value == 'm'" class="col-lg-2" description="Jika memilih pengiriman di tanggal 31, maka akan dikirimkan pada akhir tanggal di setiap bulan.">
              <multiselect
                id="day"
                v-model="form.date"
                :options="selectDateOptions"
                placeholder="1"
              ></multiselect>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="8">
            <b-form-group
              label-cols-lg="3"
              content-cols-lg="9"
              label="Penerima"
              label-for="receiver-name"
              label-class="required"
            >
              <multiselect
                id="receiver-name"
                v-model="form.receiver"
                :options="receiverOptions"
                :multiple="true"
                :close-on-select="false"
                track-by="value"
                label="text"
                placeholder="Masukkan email penerima"
                :class="{ 'is-invalid': $v.form.receiver.$error }"
              >
                <template slot="selection" slot-scope="{ values, isOpen }">
                  <div
                    class="multiselect__tags-wrap"
                    v-if="values.length && !isOpen"
                  >
                    <span class="multiselect__tag">
                      <span>{{ values[0].text }}</span>
                      <i
                        aria-hidden="true"
                        tabindex="1"
                        class="multiselect__tag-icon"
                        @click="removeMultiselectKey('form.receiver')"
                      ></i>
                    </span>
                    <span
                      class="badge bg-success px-2 py-1 d-inline-block"
                      style="font-size: 12px; overflow: hidden"
                      v-if="values.length > 1 && !isOpen"
                      >+{{ values.length - 1 }}</span
                    >
                  </div>
                </template>
              </multiselect>
              <div v-if="$v.form.receiver.$error" class="invalid-feedback">
                <span v-if="!$v.form.receiver.required">
                  Email Penerima
                  {{ $t("global.validation.required") }}
                </span>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-3" v-if="form.report.value == 2">
          <b-col cols="8">
            <b-form-group
              label-cols-lg="3"
              content-cols-lg="9"
              label="Grup Kendaraan"
              label-for="fleet-group"
              label-class="required"
            >
              <multiselect
                id="fleet-group"
                v-model="form.fleetGroup"
                :options="fleetGroup"
                :multiple="true"
                :close-on-select="false"
                track-by="value"
                label="text"
                placeholder="Pilih grup kendaraan"
                :class="{ 'is-invalid': $v.form.fleetGroup.$error }"
              >
                <template slot="selection" slot-scope="{ values, isOpen }">
                  <div
                    class="multiselect__tags-wrap"
                    v-if="values.length && !isOpen"
                  >
                    <span class="multiselect__tag">
                      <span>{{ values[0].text }}</span>
                      <i
                        aria-hidden="true"
                        tabindex="1"
                        class="multiselect__tag-icon"
                        @click="removeMultiselectKey('form.fleetGroup')"
                      ></i>
                    </span>
                    <span
                      class="badge bg-success px-2 py-1 d-inline-block"
                      style="font-size: 12px; overflow: hidden"
                      v-if="values.length > 1 && !isOpen"
                      >+{{ values.length - 1 }}</span
                    >
                  </div>
                </template>
              </multiselect>
              <div v-if="$v.form.fleetGroup.$error" class="invalid-feedback">
                <span v-if="!$v.form.fleetGroup.required">
                  Grup Kendaraan
                  {{ $t("global.validation.required") }}
                </span>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </Layout>
</template>
